import Edit from '@groovehq/internal-design-system/lib/assets/icons/FileText'

import ActionIcon from '../ActionIcon'

import { styles as baseStyles } from '../styles'
import { styles } from './styles'

export default function Sentiment() {
  return (
    <div className="grui flex items-center mt-6">
      <ActionIcon>
        <Edit />
      </ActionIcon>

      <span css={baseStyles.actionTitle}>Sentiment</span>

      <span className="grui ml-auto" css={styles.emoji}>
        😀
      </span>
    </div>
  )
}
